import { lazy, Suspense } from 'react';
import { BulkPaste } from './BulkPaste';
import { Dock } from './Dock';
import { Inspector } from './Inspector';
import { ModelTree } from './ModelTree';
import { Shortcuts } from './Shortcuts';
import { TopBar } from './TopBar';
import { ViewToolbar } from './ViewToolbar';
import w from './Workspace.module.css';
import { useStore } from '../state/store';

const Viewport = lazy(() => import('../viewport/Viewport').then((m) => ({ default: m.Viewport })));

/** What a drag is doing, while it is doing it. */
function DragReadout() {
  const text = useStore((s) => s.dragReadout);
  if (!text) return null;
  return <div className={w.readoutPill} role="status">{text}</div>;
}

function Toast() {
  const toast = useStore((s) => s.toast);
  if (!toast) return null;
  return <div key={toast.id} className={w.toast} role="status">{toast.text}</div>;
}

/**
 * Modelling needs the three panes side by side, so the workspace asks for a wide screen rather than
 * degrading into a sideways scroll. The read-only view for phones and tablets comes with share links.
 */
function TooNarrow() {
  const doc = useStore((s) => s.doc);
  return (
    <div className={w.narrow}>
      <div>
        <h1>Extent needs a wider screen</h1>
        <p>{doc ? `“${doc.meta.name}” is safe.` : 'Your work is safe.'} The model, the 3D view and the inspector sit side by side, so modelling needs a window at least 1100 pixels wide. Open this on a laptop or desktop.</p>
        <p className={w.narrowNote}>A read-only view for phones and tablets is coming with share links.</p>
      </div>
    </div>
  );
}

export function Workspace() {
  return (
    <>
    <TooNarrow />
    <div className={w.shell}>
      <TopBar />
      <ModelTree />
      <main className={w.viewport} aria-label="3D view">
        <ViewToolbar />
        <Suspense fallback={<div className={w.loading}>Loading the 3D view…</div>}>
          <Viewport />
        </Suspense>
        <DragReadout />
        <Shortcuts />
      </main>
      <Inspector />
      <Dock />
      <BulkPaste />
      <Toast />
    </div>
    </>
  );
}
